import { Button } from "@clockwise/design-system";
import { ConferencingType } from "@clockwise/schema";
import { MeetLogo } from "@clockwise/web-commons/src/components/svgs/MeetLogo";
import { TeamsLogo } from "@clockwise/web-commons/src/components/svgs/TeamsLogo";
import { ZoomLogo } from "@clockwise/web-commons/src/components/svgs/ZoomLogo";
import { SvgIconComponent, VideocamRounded as VideoConferencingIcon } from "@material-ui/icons";
import React from "react";

type Props = {
  onJoin: () => void;
  selected: ConferencingType;
};

const SelectionDetails: Record<ConferencingType, [string, SvgIconComponent]> = {
  MEET: ["Join Meet Meeting", MeetLogo],
  TEAMS_FOR_BUSINESS: ["Join Teams Meeting", TeamsLogo],
  ZOOM: ["Join Zoom Meeting", ZoomLogo],
  AROUND: ["Join Around Meeting", VideoConferencingIcon],
  OTHER: ["Join Video Meeting", VideoConferencingIcon],
};

export const JoinVideoConfAction = ({ onJoin, selected }: Props) => {
  const [text, Icon] = SelectionDetails[selected];

  return (
    <Button startIcon={Icon} onClick={onJoin} variant="text" size="xsmall">
      {text}
    </Button>
  );
};
